var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"expand-arrow",class:{ 'expanded': _vm.expanded },attrs:{"src":_vm.image}})
}
var staticRenderFns = []

export { render, staticRenderFns }